import React from "react";
import styled from "styled-components";
import { Row, Col } from 'react-bootstrap';
import "./DetalleAccions.css"

const ColS = styled(Col)`
  margin:0;
  padding: 0;

`;
const formatTooltip = (rows) => {
  let arr = rows;
  let cad = "";
  for (let i = 0; i < arr.length; i++) {
    const element = arr[i].value;
    if(i < 7){
      if(i===0){
        cad = element;
      }
      else{
        if(i===1){
          if(element !== arr[0]){
            if((i+1)%2 === 0){
              cad = cad +', '+ element;
            }else{
              cad = cad +', '+ element;
            }
          }
        }
        else{
          if((i+1)%2 === 0){
            cad = cad +', '+ element;
          }else{
            cad = cad +', '+ element;
          }
        }
      }
    }
    else{
      cad = cad + ", y mas ...";
      break;
    }
  }
  return cad;
}
/***
 * No me gusta los div por el momento lo dejare así pero 
 * podemos hacerlo con logica en lugar de divs
 */
function DetalleAccions(props){
  return (
    <>
      <ColS md={'auto'} hidden={props.showDetalleOptions.ver? false:true}>
        <button className={'customButtonDetalle'} onClick={props.verDetalle}>
          Ver Detalles
        </button>
      </ColS>
      <ColS md={'auto'} hidden={props.isDetalle?false:true}>
        <button className={'customButtonDetalle'} onClick={props.regresarDetalle}>
          <span className="fa fa-arrow-left" style={{marginRight:'4px'}}></span>
          Regresar Nivel Superior
        </button>
        <span className="span-rows-selected">{props.actualSelectedRows}</span>
        <span className="fa fa-question-circle tooltip-bar">
        <span className="tooltiptext">Elementos Seleccionados: {formatTooltip(props.actualSelectedRowsComplete)}</span>
        </span>
      </ColS>
    </>
  );
}
export default DetalleAccions;